import { gql } from "apollo-boost"

export default gql`
  query LoadContactPage {
    contactPage {
      body
    }
  }
`
